export default __webpack_public_path__ + "static/media/interior (14).96cdf456.jpg";